module.exports = __webpack_public_path__ + "img/logo-1.b447b013.png";